var React = require('react');

function WarningInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.5 7V11.55","stroke":"#FF813A","strokeWidth":"1.25","strokeLinecap":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.54995 14.95C10.0194 14.95 10.4 14.5694 10.4 14.1C10.4 13.6306 10.0194 13.25 9.54995 13.25C9.08051 13.25 8.69995 13.6306 8.69995 14.1C8.69995 14.5694 9.08051 14.95 9.54995 14.95Z","fill":"#FF813A","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.62706 1.56211C9.00868 0.879203 9.99132 0.879204 10.3729 1.56211L18.1686 15.5122C18.5411 16.1788 18.0592 17 17.2956 17H1.70437C0.940784 17 0.458935 16.1787 0.83143 15.5122L8.62706 1.56211Z","stroke":"#FF813A","strokeWidth":"1.25","strokeLinejoin":"round","key":2})]);
}

WarningInline.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = WarningInline;

WarningInline.default = WarningInline;
